<div
  id="moveableContainer"
  [ngClass]="{ mobileWrapper: isMobile }"
  class="wrapper wrapper-content animated fadeInLeft exchangeTokensContainer"
>
  <div class="row" [ngClass]="{ bgGrey: isMobile }">
    <!--<div *ngIf="loading" id="loader">
      <i class="fa fa-spinner fa-pulse fa-fw"></i>
    </div>-->

    <div id="goBackContainer" *ngIf="isMobile">
      <div class="display-flex-left">
        <div id="goBackContainer_button" (click)="goBack()">
          <i class="fa fa-angle-left"></i>
        </div>
        {{
          headCaptionList.length > 0
            ? headCaptionList[headCaptionList.length - 1]
            : ''
        }}
      </div>
      <div class="footer-default flex-fill-width text-center">
        <b>{{ headCaption }}</b>
      </div>
    </div>

    <!-------------- MOBILE -------------------->
    <app-mobile-menu
      *ngIf="isMobile"
      [currentPlan]="currentPlan"
      [currentView]="currentView"
      (acceptLTI)="(accept)"
      (onViewChange)="getInfoView($event)"
    ></app-mobile-menu>

    <div
      class="ibox float-e-margins"
      id="mainContainer"
      *ngIf="isMobile && hideMenu"
    >
      <div class="ibox-content" *ngIf="currentPlan">
        <app-bonus-accrued
          [plan]="currentPlan"
          *ngIf="currentView === 'bonusAccruedWidgetMobile'"
        ></app-bonus-accrued>
        <app-bonus-bank
          [plan]="currentPlan"
          [userId]="userId"
          *ngIf="currentView === 'bonusBankWidgetMobile'"
        ></app-bonus-bank>
        <app-bonus-payable
          [plan]="currentPlan"
          *ngIf="currentView === 'bonusPayableWidgetMobile'"
        ></app-bonus-payable>
        <app-bonus-simulation
          [plan]="currentPlan"
          *ngIf="currentView === 'bonusSimulationMobile'"
        ></app-bonus-simulation>

        <app-my-ltiform
          [plan]="currentPlan"
          *ngIf="currentView === 'myLtiFormMobile'"
        ></app-my-ltiform>
        <app-terms-conditions
          [plan]="currentPlan"
          *ngIf="currentView === 'terms&ConditionsMobile'"
        ></app-terms-conditions>
        <app-vexatious-clauses
          [plan]="currentPlan"
          *ngIf="currentView === 'vexatiousClausesMobile'"
        ></app-vexatious-clauses>

        <app-objectives-m
          [plan]="currentPlan"
          [type]="'gateways'"
          *ngIf="currentView === 'gatewaysMobile'"
        ></app-objectives-m>
        <app-objectives-m
          [plan]="currentPlan"
          [type]="'objectives'"
          *ngIf="currentView === 'objectivesMobile'"
        ></app-objectives-m>
        <app-objectives-m
          [plan]="currentPlan"
          [type]="'correctives'"
          *ngIf="currentView === 'bonusBankCorrectiveMobile'"
        ></app-objectives-m>
      </div>
    </div>
    <!-------------- MOBILE -------------------->

    <div
      class="col-md-2 no-padding1"
      id="sideHistory"
      *ngIf="!isMobile && currentPlan"
    >
      <div id="planSummary">
        <div id="planSummaryName">{{ currentPlan?.Name }}</div>
        <div id="planSummaryDescription">
          {{ 'FROM' | translate }} {{ currentPlan.YearStart }}
          {{ 'TO' | translate }} {{ currentPlan.YearEnd }}
        </div>
      </div>

      <div id="sideHistoryItem_Container">
        <div
          class="sideHistoryItem greyItem"
          [ngClass]="{ active: currentView === 'documents' }"
          (click)="setCurrentView('documents')"
        >
          <div class="sideHistoryItem-wrapper">
            <div class="title">
              <div class="sideHistoryItemTitle">
                {{ 'PARTECIPANT_LTI.SIDEBAR.DOCUMENTS' | translate }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="sideHistoryItem greyItem"
          [ngClass]="{ active: currentView === 'targetbonus' }"
          (click)="setCurrentView('targetbonus')"
        >
          <div class="sideHistoryItem-wrapper">
            <div class="title">
              <div class="sideHistoryItemTitle">
                {{ 'PARTECIPANT_LTI.SIDEBAR.TARGET_BONUS' | translate }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="sideHistoryItem greyItem"
          [ngClass]="{ active: currentView === 'objectives' }"
          (click)="setCurrentView('objectives')"
        >
          <div class="sideHistoryItem-wrapper">
            <div class="title">
              <div class="sideHistoryItemTitle">
                {{ 'PARTECIPANT_LTI.SIDEBAR.OBJECTIVES' | translate }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="sideHistoryItem whiteItem"
          [ngClass]="{ active: currentView === 'bonussimulation' }"
          (click)="setCurrentView('bonussimulation')"
        >
          <div class="sideHistoryItem-wrapper">
            <div class="title">
              <div class="sideHistoryItemTitle">
                {{ 'PARTECIPANT_LTI.SIDEBAR.BONUS_SIMULATION' | translate }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="sideHistoryItem whiteItem"
          [ngClass]="{ active: currentView === 'results' }"
          (click)="setCurrentView('results')"
        >
          <div class="sideHistoryItem-wrapper">
            <div class="title">
              <div class="sideHistoryItemTitle">
                {{ 'PARTECIPANT_LTI.SIDEBAR.RESULTS' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="col-md-10 no-padding"
      id="mainContainer"
      *ngIf="!isMobile && currentPlan"
    >
      <div class="ibox float-e-margins" id="">
        <div class="ibox-content" *ngIf="currentPlan">
          <app-documents
            #documents
            [plan]="currentPlan"
            [userId]="userId"
            *ngIf="currentView === 'documents'"
            (acceptPlan)="acceptPlan()"
          ></app-documents>
          <app-target-bonus
            [plan]="currentPlan"
            [userId]="userId"
            *ngIf="currentView === 'targetbonus'"
          ></app-target-bonus>
          <app-objectives
            [plan]="currentPlan"
            [userId]="userId"
            *ngIf="currentView === 'objectives'"
          ></app-objectives>
          <app-bonus-simulation
            [plan]="currentPlan"
            [userId]="userId"
            *ngIf="currentView === 'bonussimulation'"
          ></app-bonus-simulation>
          <app-results
            [plan]="currentPlan"
            [userId]="userId"
            *ngIf="currentView === 'results'"
          ></app-results>
        </div>
      </div>
    </div>
  </div>
</div>
